const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

export default isBrowser;
